// 所处环境
export const getEnv = () => {
  const pathname = window.location.pathname
  if (pathname.includes('pre2')) return 'pre2'
  if (pathname.includes('pre')) return 'pre'
  if (isTest()) return 'test'
  return 'public'
}

// 本地调试
export const isDevMode = () => {
  const host = window.location.host
  return !host || host.includes('localhost') || /^[0-9.:]+$/.test(host)
}

// 测试环境
export const isTest = () => {
  const host = window.location.host
  return isDevMode() || host.indexOf('test') !== -1
}
